import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimal%20abstract%20geometric%20background%20with%20warm%20amber%20and%20cream%20gradients%2C%20smooth%20flowing%20shapes%2C%20soft%20elegant%20composition%2C%20clean%20professional%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20subtle%20texture%2C%20digital%20art%20style%2C%20high%20end%20design&width=1600&height=900&seq=hero-bg-17c&orientation=landscape"
          alt="17c 平台背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
            {heroData.title}
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-3 md:mb-4 font-medium">
            {heroData.subtitle}
          </p>
          <p className="text-sm md:text-base text-white/70 mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed">
            {heroData.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category"
              className="inline-flex items-center px-8 py-3 text-sm font-semibold rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {heroData.ctaPrimary}
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center px-8 py-3 text-sm font-semibold rounded-md bg-white/10 text-white hover:bg-white/20 backdrop-blur-sm border border-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {heroData.ctaSecondary}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}